// SVG-иконки соцсетей (одноцветные, наследуют currentColor).
export function TelegramIcon({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M21.94 4.6l-3.32 15.66c-.25 1.1-.9 1.38-1.83.86l-5.05-3.72-2.44 2.35c-.27.27-.5.5-1.02.5l.36-5.14L18 6.28c.4-.36-.09-.56-.63-.2L6.7 12.98l-4.98-1.56c-1.08-.34-1.1-1.08.23-1.6l19.47-7.5c.9-.34 1.69.2 1.52 1.28z" />
    </svg>
  );
}

export function VkIcon({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M13.16 18.3c-6.34 0-9.95-4.35-10.1-11.58h3.17c.1 5.3 2.44 7.55 4.3 8.01V6.72h2.99v4.57c1.83-.2 3.75-2.28 4.4-4.57h2.98c-.5 2.82-2.58 4.9-4.06 5.75 1.48.7 3.85 2.5 4.75 5.83h-3.29c-.7-2.18-2.46-3.87-4.78-4.1v4.1h-.36z" />
    </svg>
  );
}

// Резолвер по ключу иконки из data/company.js.
// У VK глиф визуально мельче — даём ему чуть больший размер для баланса.
export default function SocialIcon({ name, size = 20 }) {
  if (name === "telegram") return <TelegramIcon size={size} />;
  if (name === "vk") return <VkIcon size={size + 4} />;
  return null;
}
